document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.querySelector('#LoadMoreButton');
  const productContainer = document.querySelector('#AjaxinateLoop');
  const paginationWrapper = document.querySelector('#AjaxinatePagination');

  if (!loadMoreBtn || !productContainer || !paginationWrapper) return;

  loadMoreBtn.addEventListener('click', function () {
    let nextLink =
      paginationWrapper.querySelector('a[rel="next"]') ||
      paginationWrapper.querySelector('.pagination__item--next a');

    if (!nextLink) {
      loadMoreBtn.style.display = 'none';
      return;
    }

    loadMoreBtn.disabled = true;
    const originalText = loadMoreBtn.textContent;
    loadMoreBtn.textContent = 'Laden...';

    fetch(nextLink.href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newLoop = doc.querySelector('#AjaxinateLoop');
        const newPagination = doc.querySelector('#AjaxinatePagination');

        if (newLoop) {
          Array.from(newLoop.children).forEach((child) => {
            productContainer.appendChild(child);
          });
        }

        if (newPagination) {
          paginationWrapper.innerHTML = newPagination.innerHTML;
        } else {
          paginationWrapper.innerHTML = '';
        }

        nextLink =
          paginationWrapper.querySelector('a[rel="next"]') ||
          paginationWrapper.querySelector('.pagination__item--next a');

        if (!nextLink) {
          loadMoreBtn.style.display = 'none';
        }
      })
      .catch((err) => {
        console.error('Load more error', err);
      })
      .finally(() => {
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = originalText;
      });
  });
});